import GroupProposalsDrawer from "./GroupProposalsDrawer";

export default GroupProposalsDrawer;
